type RuntimeConfigKey =
  | 'VITE_API_URL'
  | 'VITE_STRIPE_PUBLISHABLE_KEY'
  | 'VITE_GOOGLE_MAPS_API_KEY'
  | 'VITE_LOCALE';

export function getRuntimeConfig(key: RuntimeConfigKey): string | undefined {
  const runtimeValue = window.__ATOMFIT_CONFIG__?.[key];
  if (runtimeValue) return runtimeValue;

  return import.meta.env[key] || undefined;
}
